import * as i0 from '@angular/core';
import { Injectable, inject, InjectionToken, NgModule } from '@angular/core';
import * as i1 from '@ngrx/store';
import { createFeatureSelector, createSelector, select, Store, StoreModule } from '@ngrx/store';
import * as i2 from '@spartacus/core';
import { StateUtils, PROCESS_FEATURE, ProcessSelectors, CommandStrategy, OCC_USER_ID_ANONYMOUS, LoggerService, tryNormalizeHttpError, GlobalMessageType, SiteContextActions, UserIdService } from '@spartacus/core';
import { tap, map, take, switchMap, catchError, mergeMap, withLatestFrom, filter, auditTime } from 'rxjs/operators';
import * as i4 from '@spartacus/order/root';
import { OrderPlacedEvent, ReplenishmentOrderScheduledEvent, OrderReturnRequestFacade, OrderHistoryFacade, ReplenishmentOrderHistoryFacade, ScheduledReplenishmentOrderFacade, OrderFacade, ReorderOrderFacade, OrderAttachmentsFacade } from '@spartacus/order/root';
import { BehaviorSubject, combineLatest, of, EMPTY, using, take as take$1, switchMap as switchMap$1 } from 'rxjs';
import * as i3 from '@spartacus/cart/base/root';
import * as i1$1 from '@ngrx/effects';
import { Actions, createEffect, ofType, EffectsModule } from '@ngrx/effects';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderHistoryAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderHistoryConnector {
  constructor(adapter) {
    this.adapter = adapter;
  }
  get(userId, orderCode) {
    return this.adapter.load(userId, orderCode);
  }
  getHistory(userId, pageSize, currentPage, sort) {
    return this.adapter.loadHistory(userId, pageSize, currentPage, sort);
  }
  getConsignmentTracking(orderCode, consignmentCode, userId) {
    return this.adapter.getConsignmentTracking(orderCode, consignmentCode, userId);
  }
  cancel(userId, orderCode, cancelRequestInput) {
    return this.adapter.cancel(userId, orderCode, cancelRequestInput);
  }
  return(userId, returnRequestInput) {
    return this.adapter.createReturnRequest(userId, returnRequestInput);
  }
  getReturnRequestDetail(userId, returnRequestCode) {
    return this.adapter.loadReturnRequestDetail(userId, returnRequestCode);
  }
  getReturnRequestList(userId, pageSize, currentPage, sort) {
    return this.adapter.loadReturnRequestList(userId, pageSize, currentPage, sort);
  }
  cancelReturnRequest(userId, returnRequestCode, returnRequestModification) {
    return this.adapter.cancelReturnRequest(userId, returnRequestCode, returnRequestModification);
  }
  static {
    this.ɵfac = function OrderHistoryConnector_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderHistoryConnector)(i0.ɵɵinject(OrderHistoryAdapter));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderHistoryConnector,
      factory: OrderHistoryConnector.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderHistoryConnector, [{
    type: Injectable
  }], () => [{
    type: OrderHistoryAdapter
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConnector {
  constructor(adapter) {
    this.adapter = adapter;
  }
  placeOrder(userId, cartId, termsChecked) {
    return this.adapter.placeOrder(userId, cartId, termsChecked);
  }
  placePaymentAuthorizedOrder(userId, cartId, termsChecked) {
    return this.adapter.placePaymentAuthorizedOrder(userId, cartId, termsChecked);
  }
  static {
    this.ɵfac = function OrderConnector_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConnector)(i0.ɵɵinject(OrderAdapter));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderConnector,
      factory: OrderConnector.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConnector, [{
    type: Injectable
  }], () => [{
    type: OrderAdapter
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReorderOrderAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReorderOrderConnector {
  constructor(adapter) {
    this.adapter = adapter;
  }
  reorder(orderId, userId) {
    return this.adapter.reorder(orderId, userId);
  }
  static {
    this.ɵfac = function ReorderOrderConnector_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReorderOrderConnector)(i0.ɵɵinject(ReorderOrderAdapter));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReorderOrderConnector,
      factory: ReorderOrderConnector.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReorderOrderConnector, [{
    type: Injectable
  }], () => [{
    type: ReorderOrderAdapter
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderHistoryAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderHistoryConnector {
  constructor(adapter) {
    this.adapter = adapter;
  }
  load(userId, replenishmentOrderCode) {
    return this.adapter.load(userId, replenishmentOrderCode);
  }
  loadReplenishmentDetailsHistory(userId, replenishmentOrderCode, pageSize, currentPage, sort) {
    return this.adapter.loadReplenishmentDetailsHistory(userId, replenishmentOrderCode, pageSize, currentPage, sort);
  }
  cancelReplenishmentOrder(userId, replenishmentOrderCode) {
    return this.adapter.cancelReplenishmentOrder(userId, replenishmentOrderCode);
  }
  loadHistory(userId, pageSize, currentPage, sort) {
    return this.adapter.loadHistory(userId, pageSize, currentPage, sort);
  }
  static {
    this.ɵfac = function ReplenishmentOrderHistoryConnector_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderHistoryConnector)(i0.ɵɵinject(ReplenishmentOrderHistoryAdapter));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReplenishmentOrderHistoryConnector,
      factory: ReplenishmentOrderHistoryConnector.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderHistoryConnector, [{
    type: Injectable
  }], () => [{
    type: ReplenishmentOrderHistoryAdapter
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScheduledReplenishmentOrderAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScheduledReplenishmentOrderConnector {
  constructor(adapter) {
    this.adapter = adapter;
  }
  scheduleReplenishmentOrder(cartId, scheduleReplenishmentForm, termsChecked, userId) {
    return this.adapter.scheduleReplenishmentOrder(cartId, scheduleReplenishmentForm, termsChecked, userId);
  }
  static {
    this.ɵfac = function ScheduledReplenishmentOrderConnector_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScheduledReplenishmentOrderConnector)(i0.ɵɵinject(ScheduledReplenishmentOrderAdapter));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScheduledReplenishmentOrderConnector,
      factory: ScheduledReplenishmentOrderConnector.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScheduledReplenishmentOrderConnector, [{
    type: Injectable
  }], () => [{
    type: ScheduledReplenishmentOrderAdapter
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderAttachmentsAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderAttachmentsConnector {
  constructor() {
    this.adapter = inject(OrderAttachmentsAdapter);
  }
  getOrderAttachments(userId, orderId) {
    return this.adapter.getOrderAttachments(userId, orderId);
  }
  downloadOrderAttachment(userId, orderId, attachmentId) {
    return this.adapter.downloadOrderAttachment(userId, orderId, attachmentId);
  }
  static {
    this.ɵfac = function OrderAttachmentsConnector_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderAttachmentsConnector)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderAttachmentsConnector,
      factory: OrderAttachmentsConnector.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderAttachmentsConnector, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LOAD_CONSIGNMENT_TRACKING = '[Order] Load Consignment Tracking';
const LOAD_CONSIGNMENT_TRACKING_FAIL = '[Order] Load Consignment Tracking Fail';
const LOAD_CONSIGNMENT_TRACKING_SUCCESS = '[Order] Load Consignment Tracking Success';
const CLEAR_CONSIGNMENT_TRACKING = '[Order] Clear Consignment Tracking';
class LoadConsignmentTracking {
  constructor(payload) {
    this.payload = payload;
    this.type = LOAD_CONSIGNMENT_TRACKING;
  }
}
class LoadConsignmentTrackingFail {
  constructor(payload) {
    this.payload = payload;
    this.type = LOAD_CONSIGNMENT_TRACKING_FAIL;
    this.error = payload;
  }
}
class LoadConsignmentTrackingSuccess {
  constructor(payload) {
    this.payload = payload;
    this.type = LOAD_CONSIGNMENT_TRACKING_SUCCESS;
  }
}
class ClearConsignmentTracking {
  constructor() {
    this.type = CLEAR_CONSIGNMENT_TRACKING;
    // Intentional empty constructor
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ORDER_FEATURE = 'order';
const CANCEL_ORDER_PROCESS_ID = 'cancelOrder';
const CANCEL_RETURN_PROCESS_ID = 'cancelReturn';
const CANCEL_REPLENISHMENT_ORDER_PROCESS_ID = 'cancelReplenishmentOrder';
const ORDERS = '[Order] User Orders';
const RETURN_REQUESTS = '[Order] Order Return Requests';
const RETURN_REQUEST_DETAILS = '[Order] Return Request Details';
const ORDER_DETAILS = '[Order] User Order Details';
const REPLENISHMENT_ORDERS = '[Order] User Replenishment Orders';
const REPLENISHMENT_ORDER_DETAILS = '[Order] User Replenishment Order Details';
const CONSIGNMENT_TRACKING_BY_ID_ENTITIES = 'consignment-tracking-by-id-entities';
const ORDER_BY_ID_ENTITIES = 'order-by-id-entities';
function getConsignmentTrackingByIdEntityKey(orderCode, consignmentCode) {
  return `${orderCode},${consignmentCode}`;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LOAD_ORDER_DETAILS = '[Order] Load Order Details';
const LOAD_ORDER_DETAILS_FAIL = '[Order] Load Order Details Fail';
const LOAD_ORDER_DETAILS_SUCCESS = '[Order] Load Order Details Success';
const CLEAR_ORDER_DETAILS = '[Order] Clear Order Details';
const CANCEL_ORDER = '[Order] Cancel Order';
const CANCEL_ORDER_FAIL = '[Order] Cancel Order Fail';
const CANCEL_ORDER_SUCCESS = '[Order] Cancel Order Success';
const RESET_CANCEL_ORDER_PROCESS = '[Order] Reset Cancel Order Process';
class LoadOrderDetails extends StateUtils.LoaderLoadAction {
  constructor(payload) {
    super(ORDER_DETAILS);
    this.payload = payload;
    this.type = LOAD_ORDER_DETAILS;
  }
}
class LoadOrderDetailsFail extends StateUtils.LoaderFailAction {
  constructor(payload) {
    super(ORDER_DETAILS, payload);
    this.payload = payload;
    this.type = LOAD_ORDER_DETAILS_FAIL;
  }
}
class LoadOrderDetailsSuccess extends StateUtils.LoaderSuccessAction {
  constructor(payload) {
    super(ORDER_DETAILS);
    this.payload = payload;
    this.type = LOAD_ORDER_DETAILS_SUCCESS;
  }
}
class ClearOrderDetails extends StateUtils.LoaderResetAction {
  constructor() {
    super(ORDER_DETAILS);
    this.type = CLEAR_ORDER_DETAILS;
  }
}
class CancelOrder extends StateUtils.EntityLoadAction {
  constructor(payload) {
    super(PROCESS_FEATURE, CANCEL_ORDER_PROCESS_ID);
    this.payload = payload;
    this.type = CANCEL_ORDER;
  }
}
class CancelOrderFail extends StateUtils.EntityFailAction {
  constructor(payload) {
    super(PROCESS_FEATURE, CANCEL_ORDER_PROCESS_ID, payload);
    this.payload = payload;
    this.type = CANCEL_ORDER_FAIL;
  }
}
class CancelOrderSuccess extends StateUtils.EntitySuccessAction {
  constructor() {
    super(PROCESS_FEATURE, CANCEL_ORDER_PROCESS_ID);
    this.type = CANCEL_ORDER_SUCCESS;
  }
}
class ResetCancelOrderProcess extends StateUtils.EntityLoaderResetAction {
  constructor() {
    super(PROCESS_FEATURE, CANCEL_ORDER_PROCESS_ID);
    this.type = RESET_CANCEL_ORDER_PROCESS;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CREATE_ORDER_RETURN_REQUEST = '[Order] Create Order Return Request';
const CREATE_ORDER_RETURN_REQUEST_FAIL = '[Order] Create Order Return Request Fail';
const CREATE_ORDER_RETURN_REQUEST_SUCCESS = '[Order] Create Order Return Request Success';
const LOAD_ORDER_RETURN_REQUEST = '[Order] Load Order Return Request details';
const LOAD_ORDER_RETURN_REQUEST_FAIL = '[Order] Load Order Return Request details Fail';
const LOAD_ORDER_RETURN_REQUEST_SUCCESS = '[Order] Load Order Return Request details Success';
const CANCEL_ORDER_RETURN_REQUEST = '[Order] Cancel Order Return Request';
const CANCEL_ORDER_RETURN_REQUEST_FAIL = '[Order] Cancel Order Return Request Fail';
const CANCEL_ORDER_RETURN_REQUEST_SUCCESS = '[Order] Cancel Order Return Request Success';
const LOAD_ORDER_RETURN_REQUEST_LIST = '[Order] Load User Order Return Request List';
const LOAD_ORDER_RETURN_REQUEST_LIST_FAIL = '[Order] Load User Order Return Request List Fail';
const LOAD_ORDER_RETURN_REQUEST_LIST_SUCCESS = '[Order] Load User Order Return Request List Success';
const CLEAR_ORDER_RETURN_REQUEST = '[Order] Clear Order Return Request Details';
const CLEAR_ORDER_RETURN_REQUEST_LIST = '[Order] Clear Order Return Request List';
const RESET_CANCEL_RETURN_PROCESS = '[Order] Reset Cancel Return Request Process';
class CreateOrderReturnRequest extends StateUtils.LoaderLoadAction {
  constructor(payload) {
    super(RETURN_REQUEST_DETAILS);
    this.payload = payload;
    this.type = CREATE_ORDER_RETURN_REQUEST;
  }
}
class CreateOrderReturnRequestFail extends StateUtils.LoaderFailAction {
  constructor(payload) {
    super(RETURN_REQUEST_DETAILS, payload);
    this.payload = payload;
    this.type = CREATE_ORDER_RETURN_REQUEST_FAIL;
  }
}
class CreateOrderReturnRequestSuccess extends StateUtils.LoaderSuccessAction {
  constructor(payload) {
    super(RETURN_REQUEST_DETAILS);
    this.payload = payload;
    this.type = CREATE_ORDER_RETURN_REQUEST_SUCCESS;
  }
}
class LoadOrderReturnRequest extends StateUtils.LoaderLoadAction {
  constructor(payload) {
    super(RETURN_REQUEST_DETAILS);
    this.payload = payload;
    this.type = LOAD_ORDER_RETURN_REQUEST;
  }
}
class LoadOrderReturnRequestFail extends StateUtils.LoaderFailAction {
  constructor(payload) {
    super(RETURN_REQUEST_DETAILS, payload);
    this.payload = payload;
    this.type = LOAD_ORDER_RETURN_REQUEST_FAIL;
  }
}
class LoadOrderReturnRequestSuccess extends StateUtils.LoaderSuccessAction {
  constructor(payload) {
    super(RETURN_REQUEST_DETAILS);
    this.payload = payload;
    this.type = LOAD_ORDER_RETURN_REQUEST_SUCCESS;
  }
}
class CancelOrderReturnRequest extends StateUtils.EntityLoadAction {
  constructor(payload) {
    super(PROCESS_FEATURE, CANCEL_RETURN_PROCESS_ID);
    this.payload = payload;
    this.type = CANCEL_ORDER_RETURN_REQUEST;
  }
}
class CancelOrderReturnRequestFail extends StateUtils.EntityFailAction {
  constructor(payload) {
    super(PROCESS_FEATURE, CANCEL_RETURN_PROCESS_ID, payload);
    this.payload = payload;
    this.type = CANCEL_ORDER_RETURN_REQUEST_FAIL;
  }
}
class CancelOrderReturnRequestSuccess extends StateUtils.EntitySuccessAction {
  constructor() {
    super(PROCESS_FEATURE, CANCEL_RETURN_PROCESS_ID);
    this.type = CANCEL_ORDER_RETURN_REQUEST_SUCCESS;
  }
}
class LoadOrderReturnRequestList extends StateUtils.LoaderLoadAction {
  constructor(payload) {
    super(RETURN_REQUESTS);
    this.payload = payload;
    this.type = LOAD_ORDER_RETURN_REQUEST_LIST;
  }
}
class LoadOrderReturnRequestListFail extends StateUtils.LoaderFailAction {
  constructor(payload) {
    super(RETURN_REQUESTS, payload);
    this.payload = payload;
    this.type = LOAD_ORDER_RETURN_REQUEST_LIST_FAIL;
  }
}
class LoadOrderReturnRequestListSuccess extends StateUtils.LoaderSuccessAction {
  constructor(payload) {
    super(RETURN_REQUESTS);
    this.payload = payload;
    this.type = LOAD_ORDER_RETURN_REQUEST_LIST_SUCCESS;
  }
}
class ClearOrderReturnRequest extends StateUtils.LoaderResetAction {
  constructor() {
    super(RETURN_REQUEST_DETAILS);
    this.type = CLEAR_ORDER_RETURN_REQUEST;
  }
}
class ClearOrderReturnRequestList extends StateUtils.LoaderResetAction {
  constructor() {
    super(RETURN_REQUESTS);
    this.type = CLEAR_ORDER_RETURN_REQUEST_LIST;
  }
}
class ResetCancelReturnProcess extends StateUtils.EntityLoaderResetAction {
  constructor() {
    super(PROCESS_FEATURE, CANCEL_RETURN_PROCESS_ID);
    this.type = RESET_CANCEL_RETURN_PROCESS;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LOAD_USER_ORDERS = '[Order] Load User Orders';
const LOAD_USER_ORDERS_FAIL = '[Order] Load User Orders Fail';
const LOAD_USER_ORDERS_SUCCESS = '[Order] Load User Orders Success';
const CLEAR_USER_ORDERS = '[Order] Clear User Orders';
class LoadUserOrders extends StateUtils.LoaderLoadAction {
  constructor(payload) {
    super(ORDERS);
    this.payload = payload;
    this.type = LOAD_USER_ORDERS;
  }
}
class LoadUserOrdersFail extends StateUtils.LoaderFailAction {
  constructor(payload) {
    super(ORDERS, payload);
    this.payload = payload;
    this.type = LOAD_USER_ORDERS_FAIL;
  }
}
class LoadUserOrdersSuccess extends StateUtils.LoaderSuccessAction {
  constructor(payload) {
    super(ORDERS);
    this.payload = payload;
    this.type = LOAD_USER_ORDERS_SUCCESS;
  }
}
class ClearUserOrders extends StateUtils.LoaderResetAction {
  constructor() {
    super(ORDERS);
    this.type = CLEAR_USER_ORDERS;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LOAD_REPLENISHMENT_ORDER_DETAILS = '[Order] Load Replenishment Order Details';
const LOAD_REPLENISHMENT_ORDER_DETAILS_SUCCESS = '[Order] Load Replenishment Order Details Success';
const LOAD_REPLENISHMENT_ORDER_DETAILS_FAIL = '[Order] Load Replenishment Order Details Fail';
const ClEAR_REPLENISHMENT_ORDER_DETAILS = '[Order] Clear Replenishment Order Details';
const CANCEL_REPLENISHMENT_ORDER = '[Order] Cancel Replenishment Order';
const CANCEL_REPLENISHMENT_ORDER_SUCCESS = '[Order] Cancel Replenishment Order Success';
const CANCEL_REPLENISHMENT_ORDER_FAIL = '[Order] Cancel Replenishment Order Fail';
const CLEAR_CANCEL_REPLENISHMENT_ORDER = '[Order] Clear Cancel Replenishment Order';
class LoadReplenishmentOrderDetails extends StateUtils.LoaderLoadAction {
  constructor(payload) {
    super(REPLENISHMENT_ORDER_DETAILS);
    this.payload = payload;
    this.type = LOAD_REPLENISHMENT_ORDER_DETAILS;
  }
}
class LoadReplenishmentOrderDetailsSuccess extends StateUtils.LoaderSuccessAction {
  constructor(payload) {
    super(REPLENISHMENT_ORDER_DETAILS);
    this.payload = payload;
    this.type = LOAD_REPLENISHMENT_ORDER_DETAILS_SUCCESS;
  }
}
class LoadReplenishmentOrderDetailsFail extends StateUtils.LoaderFailAction {
  constructor(payload) {
    super(REPLENISHMENT_ORDER_DETAILS, payload);
    this.payload = payload;
    this.type = LOAD_REPLENISHMENT_ORDER_DETAILS_FAIL;
  }
}
class ClearReplenishmentOrderDetails extends StateUtils.LoaderResetAction {
  constructor() {
    super(REPLENISHMENT_ORDER_DETAILS);
    this.type = ClEAR_REPLENISHMENT_ORDER_DETAILS;
  }
}
class CancelReplenishmentOrder extends StateUtils.EntityLoadAction {
  constructor(payload) {
    super(PROCESS_FEATURE, CANCEL_REPLENISHMENT_ORDER_PROCESS_ID);
    this.payload = payload;
    this.type = CANCEL_REPLENISHMENT_ORDER;
  }
}
class CancelReplenishmentOrderSuccess extends StateUtils.EntitySuccessAction {
  constructor(payload) {
    super(PROCESS_FEATURE, CANCEL_REPLENISHMENT_ORDER_PROCESS_ID);
    this.payload = payload;
    this.type = CANCEL_REPLENISHMENT_ORDER_SUCCESS;
  }
}
class CancelReplenishmentOrderFail extends StateUtils.EntityFailAction {
  constructor(payload) {
    super(PROCESS_FEATURE, CANCEL_REPLENISHMENT_ORDER_PROCESS_ID, payload);
    this.payload = payload;
    this.type = CANCEL_REPLENISHMENT_ORDER_FAIL;
  }
}
class ClearCancelReplenishmentOrder extends StateUtils.EntityLoaderResetAction {
  constructor() {
    super(PROCESS_FEATURE, CANCEL_REPLENISHMENT_ORDER_PROCESS_ID);
    this.type = CLEAR_CANCEL_REPLENISHMENT_ORDER;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LOAD_USER_REPLENISHMENT_ORDERS = '[Order] Load User Replenishment Orders';
const LOAD_USER_REPLENISHMENT_ORDERS_FAIL = '[Order] Load User Replenishment Orders Fail';
const LOAD_USER_REPLENISHMENT_ORDERS_SUCCESS = '[Order] Load User Replenishment Orders Success';
const CLEAR_USER_REPLENISHMENT_ORDERS = '[Order] Clear User Replenishment Orders';
class LoadUserReplenishmentOrders extends StateUtils.LoaderLoadAction {
  constructor(payload) {
    super(REPLENISHMENT_ORDERS);
    this.payload = payload;
    this.type = LOAD_USER_REPLENISHMENT_ORDERS;
  }
}
class LoadUserReplenishmentOrdersFail extends StateUtils.LoaderFailAction {
  constructor(payload) {
    super(REPLENISHMENT_ORDERS, payload);
    this.payload = payload;
    this.type = LOAD_USER_REPLENISHMENT_ORDERS_FAIL;
  }
}
class LoadUserReplenishmentOrdersSuccess extends StateUtils.LoaderSuccessAction {
  constructor(payload) {
    super(REPLENISHMENT_ORDERS);
    this.payload = payload;
    this.type = LOAD_USER_REPLENISHMENT_ORDERS_SUCCESS;
  }
}
class ClearUserReplenishmentOrders extends StateUtils.LoaderResetAction {
  constructor() {
    super(REPLENISHMENT_ORDERS);
    this.type = CLEAR_USER_REPLENISHMENT_ORDERS;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LOAD_CONSIGNMENT_TRACKING_BY_ID = '[Order] Load Consignment Tracking By ID Data';
const LOAD_CONSIGNMENT_TRACKING_BY_ID_FAIL = '[Order] Load  Consignment Tracking By ID Data Fail';
const LOAD_CONSIGNMENT_TRACKING_BY_ID_SUCCESS = '[Order] Load Consignment Tracking By ID Data Success';
class LoadConsignmentTrackingById extends StateUtils.EntityLoadAction {
  constructor(payload) {
    super(CONSIGNMENT_TRACKING_BY_ID_ENTITIES, getConsignmentTrackingByIdEntityKey(payload.orderCode, payload.consignmentCode));
    this.payload = payload;
    this.type = LOAD_CONSIGNMENT_TRACKING_BY_ID;
  }
}
class LoadConsignmentTrackingByIdFail extends StateUtils.EntityFailAction {
  constructor(payload) {
    super(CONSIGNMENT_TRACKING_BY_ID_ENTITIES, getConsignmentTrackingByIdEntityKey(payload.orderCode, payload.consignmentCode), payload.error);
    this.payload = payload;
    this.type = LOAD_CONSIGNMENT_TRACKING_BY_ID_FAIL;
  }
}
class LoadConsignmentTrackingByIdSuccess extends StateUtils.EntitySuccessAction {
  constructor(payload) {
    super(CONSIGNMENT_TRACKING_BY_ID_ENTITIES, getConsignmentTrackingByIdEntityKey(payload.orderCode, payload.consignmentCode));
    this.payload = payload;
    this.type = LOAD_CONSIGNMENT_TRACKING_BY_ID_SUCCESS;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LOAD_ORDER_BY_ID = '[Order] Load Order By ID Data';
const LOAD_ORDER_BY_ID_FAIL = '[Order] Load Order By ID Data Fail';
const LOAD_ORDER_BY_ID_SUCCESS = '[Order] Load Order By ID Data Success';
class LoadOrderById extends StateUtils.EntityLoadAction {
  constructor(payload) {
    super(ORDER_BY_ID_ENTITIES, payload.code);
    this.payload = payload;
    this.type = LOAD_ORDER_BY_ID;
  }
}
class LoadOrderByIdFail extends StateUtils.EntityFailAction {
  constructor(payload) {
    super(ORDER_BY_ID_ENTITIES, payload.code, payload.error);
    this.payload = payload;
    this.type = LOAD_ORDER_BY_ID_FAIL;
  }
}
class LoadOrderByIdSuccess extends StateUtils.EntitySuccessAction {
  constructor(payload) {
    super(ORDER_BY_ID_ENTITIES, payload.code ?? '');
    this.payload = payload;
    this.type = LOAD_ORDER_BY_ID_SUCCESS;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

var orderGroup_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CANCEL_ORDER: CANCEL_ORDER,
  CANCEL_ORDER_FAIL: CANCEL_ORDER_FAIL,
  CANCEL_ORDER_RETURN_REQUEST: CANCEL_ORDER_RETURN_REQUEST,
  CANCEL_ORDER_RETURN_REQUEST_FAIL: CANCEL_ORDER_RETURN_REQUEST_FAIL,
  CANCEL_ORDER_RETURN_REQUEST_SUCCESS: CANCEL_ORDER_RETURN_REQUEST_SUCCESS,
  CANCEL_ORDER_SUCCESS: CANCEL_ORDER_SUCCESS,
  CANCEL_REPLENISHMENT_ORDER: CANCEL_REPLENISHMENT_ORDER,
  CANCEL_REPLENISHMENT_ORDER_FAIL: CANCEL_REPLENISHMENT_ORDER_FAIL,
  CANCEL_REPLENISHMENT_ORDER_SUCCESS: CANCEL_REPLENISHMENT_ORDER_SUCCESS,
  CLEAR_CANCEL_REPLENISHMENT_ORDER: CLEAR_CANCEL_REPLENISHMENT_ORDER,
  CLEAR_CONSIGNMENT_TRACKING: CLEAR_CONSIGNMENT_TRACKING,
  CLEAR_ORDER_DETAILS: CLEAR_ORDER_DETAILS,
  CLEAR_ORDER_RETURN_REQUEST: CLEAR_ORDER_RETURN_REQUEST,
  CLEAR_ORDER_RETURN_REQUEST_LIST: CLEAR_ORDER_RETURN_REQUEST_LIST,
  CLEAR_USER_ORDERS: CLEAR_USER_ORDERS,
  CLEAR_USER_REPLENISHMENT_ORDERS: CLEAR_USER_REPLENISHMENT_ORDERS,
  CREATE_ORDER_RETURN_REQUEST: CREATE_ORDER_RETURN_REQUEST,
  CREATE_ORDER_RETURN_REQUEST_FAIL: CREATE_ORDER_RETURN_REQUEST_FAIL,
  CREATE_ORDER_RETURN_REQUEST_SUCCESS: CREATE_ORDER_RETURN_REQUEST_SUCCESS,
  CancelOrder: CancelOrder,
  CancelOrderFail: CancelOrderFail,
  CancelOrderReturnRequest: CancelOrderReturnRequest,
  CancelOrderReturnRequestFail: CancelOrderReturnRequestFail,
  CancelOrderReturnRequestSuccess: CancelOrderReturnRequestSuccess,
  CancelOrderSuccess: CancelOrderSuccess,
  CancelReplenishmentOrder: CancelReplenishmentOrder,
  CancelReplenishmentOrderFail: CancelReplenishmentOrderFail,
  CancelReplenishmentOrderSuccess: CancelReplenishmentOrderSuccess,
  ClEAR_REPLENISHMENT_ORDER_DETAILS: ClEAR_REPLENISHMENT_ORDER_DETAILS,
  ClearCancelReplenishmentOrder: ClearCancelReplenishmentOrder,
  ClearConsignmentTracking: ClearConsignmentTracking,
  ClearOrderDetails: ClearOrderDetails,
  ClearOrderReturnRequest: ClearOrderReturnRequest,
  ClearOrderReturnRequestList: ClearOrderReturnRequestList,
  ClearReplenishmentOrderDetails: ClearReplenishmentOrderDetails,
  ClearUserOrders: ClearUserOrders,
  ClearUserReplenishmentOrders: ClearUserReplenishmentOrders,
  CreateOrderReturnRequest: CreateOrderReturnRequest,
  CreateOrderReturnRequestFail: CreateOrderReturnRequestFail,
  CreateOrderReturnRequestSuccess: CreateOrderReturnRequestSuccess,
  LOAD_CONSIGNMENT_TRACKING: LOAD_CONSIGNMENT_TRACKING,
  LOAD_CONSIGNMENT_TRACKING_BY_ID: LOAD_CONSIGNMENT_TRACKING_BY_ID,
  LOAD_CONSIGNMENT_TRACKING_BY_ID_FAIL: LOAD_CONSIGNMENT_TRACKING_BY_ID_FAIL,
  LOAD_CONSIGNMENT_TRACKING_BY_ID_SUCCESS: LOAD_CONSIGNMENT_TRACKING_BY_ID_SUCCESS,
  LOAD_CONSIGNMENT_TRACKING_FAIL: LOAD_CONSIGNMENT_TRACKING_FAIL,
  LOAD_CONSIGNMENT_TRACKING_SUCCESS: LOAD_CONSIGNMENT_TRACKING_SUCCESS,
  LOAD_ORDER_BY_ID: LOAD_ORDER_BY_ID,
  LOAD_ORDER_BY_ID_FAIL: LOAD_ORDER_BY_ID_FAIL,
  LOAD_ORDER_BY_ID_SUCCESS: LOAD_ORDER_BY_ID_SUCCESS,
  LOAD_ORDER_DETAILS: LOAD_ORDER_DETAILS,
  LOAD_ORDER_DETAILS_FAIL: LOAD_ORDER_DETAILS_FAIL,
  LOAD_ORDER_DETAILS_SUCCESS: LOAD_ORDER_DETAILS_SUCCESS,
  LOAD_ORDER_RETURN_REQUEST: LOAD_ORDER_RETURN_REQUEST,
  LOAD_ORDER_RETURN_REQUEST_FAIL: LOAD_ORDER_RETURN_REQUEST_FAIL,
  LOAD_ORDER_RETURN_REQUEST_LIST: LOAD_ORDER_RETURN_REQUEST_LIST,
  LOAD_ORDER_RETURN_REQUEST_LIST_FAIL: LOAD_ORDER_RETURN_REQUEST_LIST_FAIL,
  LOAD_ORDER_RETURN_REQUEST_LIST_SUCCESS: LOAD_ORDER_RETURN_REQUEST_LIST_SUCCESS,
  LOAD_ORDER_RETURN_REQUEST_SUCCESS: LOAD_ORDER_RETURN_REQUEST_SUCCESS,
  LOAD_REPLENISHMENT_ORDER_DETAILS: LOAD_REPLENISHMENT_ORDER_DETAILS,
  LOAD_REPLENISHMENT_ORDER_DETAILS_FAIL: LOAD_REPLENISHMENT_ORDER_DETAILS_FAIL,
  LOAD_REPLENISHMENT_ORDER_DETAILS_SUCCESS: LOAD_REPLENISHMENT_ORDER_DETAILS_SUCCESS,
  LOAD_USER_ORDERS: LOAD_USER_ORDERS,
  LOAD_USER_ORDERS_FAIL: LOAD_USER_ORDERS_FAIL,
  LOAD_USER_ORDERS_SUCCESS: LOAD_USER_ORDERS_SUCCESS,
  LOAD_USER_REPLENISHMENT_ORDERS: LOAD_USER_REPLENISHMENT_ORDERS,
  LOAD_USER_REPLENISHMENT_ORDERS_FAIL: LOAD_USER_REPLENISHMENT_ORDERS_FAIL,
  LOAD_USER_REPLENISHMENT_ORDERS_SUCCESS: LOAD_USER_REPLENISHMENT_ORDERS_SUCCESS,
  LoadConsignmentTracking: LoadConsignmentTracking,
  LoadConsignmentTrackingById: LoadConsignmentTrackingById,
  LoadConsignmentTrackingByIdFail: LoadConsignmentTrackingByIdFail,
  LoadConsignmentTrackingByIdSuccess: LoadConsignmentTrackingByIdSuccess,
  LoadConsignmentTrackingFail: LoadConsignmentTrackingFail,
  LoadConsignmentTrackingSuccess: LoadConsignmentTrackingSuccess,
  LoadOrderById: LoadOrderById,
  LoadOrderByIdFail: LoadOrderByIdFail,
  LoadOrderByIdSuccess: LoadOrderByIdSuccess,
  LoadOrderDetails: LoadOrderDetails,
  LoadOrderDetailsFail: LoadOrderDetailsFail,
  LoadOrderDetailsSuccess: LoadOrderDetailsSuccess,
  LoadOrderReturnRequest: LoadOrderReturnRequest,
  LoadOrderReturnRequestFail: LoadOrderReturnRequestFail,
  LoadOrderReturnRequestList: LoadOrderReturnRequestList,
  LoadOrderReturnRequestListFail: LoadOrderReturnRequestListFail,
  LoadOrderReturnRequestListSuccess: LoadOrderReturnRequestListSuccess,
  LoadOrderReturnRequestSuccess: LoadOrderReturnRequestSuccess,
  LoadReplenishmentOrderDetails: LoadReplenishmentOrderDetails,
  LoadReplenishmentOrderDetailsFail: LoadReplenishmentOrderDetailsFail,
  LoadReplenishmentOrderDetailsSuccess: LoadReplenishmentOrderDetailsSuccess,
  LoadUserOrders: LoadUserOrders,
  LoadUserOrdersFail: LoadUserOrdersFail,
  LoadUserOrdersSuccess: LoadUserOrdersSuccess,
  LoadUserReplenishmentOrders: LoadUserReplenishmentOrders,
  LoadUserReplenishmentOrdersFail: LoadUserReplenishmentOrdersFail,
  LoadUserReplenishmentOrdersSuccess: LoadUserReplenishmentOrdersSuccess,
  RESET_CANCEL_ORDER_PROCESS: RESET_CANCEL_ORDER_PROCESS,
  RESET_CANCEL_RETURN_PROCESS: RESET_CANCEL_RETURN_PROCESS,
  ResetCancelOrderProcess: ResetCancelOrderProcess,
  ResetCancelReturnProcess: ResetCancelReturnProcess
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getOrderState = createFeatureSelector(ORDER_FEATURE);

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getConsignmentTrackingState = createSelector(getOrderState, state => state.consignmentTracking);
const getConsignmentTracking = createSelector(getConsignmentTrackingState, state => state.tracking);

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getOrderDetailState = createSelector(getOrderState, state => state.orderDetail);
const getOrderDetails = createSelector(getOrderDetailState, state => StateUtils.loaderValueSelector(state));
const getOrderDetailsLoading = createSelector(getOrderDetailState, state => StateUtils.loaderLoadingSelector(state));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getOrderReturnRequestState = createSelector(getOrderState, state => state.orderReturn);
const getOrderReturnRequest = createSelector(getOrderReturnRequestState, state => StateUtils.loaderValueSelector(state));
const getOrderReturnRequestLoading = createSelector(getOrderReturnRequestState, state => StateUtils.loaderLoadingSelector(state));
const getOrderReturnRequestSuccess = createSelector(getOrderReturnRequestState, state => StateUtils.loaderSuccessSelector(state) && !StateUtils.loaderLoadingSelector(state));
const getOrderReturnRequestListState = createSelector(getOrderState, state => state.orderReturnList);
const getOrderReturnRequestList = createSelector(getOrderReturnRequestListState, state => StateUtils.loaderValueSelector(state));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getOrdersState = createSelector(getOrderState, state => state.orders);
const getOrdersLoaded = createSelector(getOrdersState, state => StateUtils.loaderSuccessSelector(state));
const getOrders = createSelector(getOrdersState, state => StateUtils.loaderValueSelector(state));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getReplenishmentOrderState = createSelector(getOrderState, state => state.replenishmentOrder);
const getReplenishmentOrderDetailsValue = createSelector(getReplenishmentOrderState, state => StateUtils.loaderValueSelector(state));
const getReplenishmentOrderDetailsLoading = createSelector(getReplenishmentOrderState, state => StateUtils.loaderLoadingSelector(state));
const getReplenishmentOrderDetailsSuccess = createSelector(getReplenishmentOrderState, state => StateUtils.loaderSuccessSelector(state));
const getReplenishmentOrderDetailsError = createSelector(getReplenishmentOrderState, state => StateUtils.loaderErrorSelector(state));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getReplenishmentOrdersState = createSelector(getOrderState, state => state.replenishmentOrders);
const getReplenishmentOrders = createSelector(getReplenishmentOrdersState, state => StateUtils.loaderValueSelector(state));
const getReplenishmentOrdersLoading = createSelector(getReplenishmentOrdersState, state => StateUtils.loaderLoadingSelector(state));
const getReplenishmentOrdersError = createSelector(getReplenishmentOrdersState, state => StateUtils.loaderErrorSelector(state));
const getReplenishmentOrdersSuccess = createSelector(getReplenishmentOrdersState, state => StateUtils.loaderSuccessSelector(state));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getConsignmentTrackingByIdEntities = createSelector(getOrderState, state => state.consignmentTrackingById);
const getConsignmentTrackingByIdEntity = (orderCode, consignmentCode) => createSelector(getConsignmentTrackingByIdEntities, state => StateUtils.entityLoaderStateSelector(state, getConsignmentTrackingByIdEntityKey(orderCode, consignmentCode)));
const getConsignmentTrackingById = (orderCode, consignmentCode) => {
  return createSelector(getConsignmentTrackingByIdEntity(orderCode, consignmentCode), consignmentTrackingByIdState => StateUtils.loaderValueSelector(consignmentTrackingByIdState));
};
const getConsignmentTrackingByIdLoading = (orderCode, consignmentCode) => {
  return createSelector(getConsignmentTrackingByIdEntity(orderCode, consignmentCode), loaderState => StateUtils.loaderLoadingSelector(loaderState));
};
const getConsignmentTrackingByIdSuccess = (orderCode, consignmentCode) => {
  return createSelector(getConsignmentTrackingByIdEntity(orderCode, consignmentCode), loaderState => StateUtils.loaderSuccessSelector(loaderState));
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const getOrderByIdEntities = createSelector(getOrderState, state => state.orderById);
const getOrderByIdEntity = code => createSelector(getOrderByIdEntities, state => StateUtils.entityLoaderStateSelector(state, code));
const getOrderById = code => {
  return createSelector(getOrderByIdEntity(code), orderByIDState => StateUtils.loaderValueSelector(orderByIDState));
};
const getOrderByIdLoading = code => {
  return createSelector(getOrderByIdEntity(code), loaderState => StateUtils.loaderLoadingSelector(loaderState));
};
const getOrderByIdSuccess = code => {
  return createSelector(getOrderByIdEntity(code), loaderState => StateUtils.loaderSuccessSelector(loaderState));
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

var orderGroup_selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getConsignmentTracking: getConsignmentTracking,
  getConsignmentTrackingById: getConsignmentTrackingById,
  getConsignmentTrackingByIdEntities: getConsignmentTrackingByIdEntities,
  getConsignmentTrackingByIdEntity: getConsignmentTrackingByIdEntity,
  getConsignmentTrackingByIdLoading: getConsignmentTrackingByIdLoading,
  getConsignmentTrackingByIdSuccess: getConsignmentTrackingByIdSuccess,
  getConsignmentTrackingState: getConsignmentTrackingState,
  getOrderById: getOrderById,
  getOrderByIdEntities: getOrderByIdEntities,
  getOrderByIdEntity: getOrderByIdEntity,
  getOrderByIdLoading: getOrderByIdLoading,
  getOrderByIdSuccess: getOrderByIdSuccess,
  getOrderDetailState: getOrderDetailState,
  getOrderDetails: getOrderDetails,
  getOrderDetailsLoading: getOrderDetailsLoading,
  getOrderReturnRequest: getOrderReturnRequest,
  getOrderReturnRequestList: getOrderReturnRequestList,
  getOrderReturnRequestListState: getOrderReturnRequestListState,
  getOrderReturnRequestLoading: getOrderReturnRequestLoading,
  getOrderReturnRequestState: getOrderReturnRequestState,
  getOrderReturnRequestSuccess: getOrderReturnRequestSuccess,
  getOrderState: getOrderState,
  getOrders: getOrders,
  getOrdersLoaded: getOrdersLoaded,
  getOrdersState: getOrdersState,
  getReplenishmentOrderDetailsError: getReplenishmentOrderDetailsError,
  getReplenishmentOrderDetailsLoading: getReplenishmentOrderDetailsLoading,
  getReplenishmentOrderDetailsSuccess: getReplenishmentOrderDetailsSuccess,
  getReplenishmentOrderDetailsValue: getReplenishmentOrderDetailsValue,
  getReplenishmentOrderState: getReplenishmentOrderState,
  getReplenishmentOrders: getReplenishmentOrders,
  getReplenishmentOrdersError: getReplenishmentOrdersError,
  getReplenishmentOrdersLoading: getReplenishmentOrdersLoading,
  getReplenishmentOrdersState: getReplenishmentOrdersState,
  getReplenishmentOrdersSuccess: getReplenishmentOrdersSuccess
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderHistoryService {
  constructor(store, processStateStore, userIdService, routingService) {
    this.store = store;
    this.processStateStore = processStateStore;
    this.userIdService = userIdService;
    this.routingService = routingService;
  }
  /**
   * Returns an order's detail
   */
  getOrderDetails() {
    return this.store.pipe(select(getOrderDetails));
  }
  /**
   * Retrieves order's details
   *
   * @param orderCode an order code
   */
  loadOrderDetails(orderCode) {
    this.userIdService.takeUserId().subscribe(userId => {
      this.store.dispatch(new LoadOrderDetails({
        userId,
        orderCode
      }));
    });
  }
  /**
   * Clears order's details
   */
  clearOrderDetails() {
    this.store.dispatch(new ClearOrderDetails());
  }
  /**
   * Returns order history list
   */
  getOrderHistoryList(pageSize) {
    return this.store.pipe(select(getOrdersState), tap(orderListState => {
      const attemptedLoad = orderListState.loading || orderListState.success || orderListState.error;
      if (!attemptedLoad) {
        this.loadOrderList(pageSize);
      }
    }), map(orderListState => orderListState.value));
  }
  /**
   * Returns a loaded flag for order history list
   */
  getOrderHistoryListLoaded() {
    return this.store.pipe(select(getOrdersLoaded));
  }
  /**
   * Retrieves an order list
   * @param pageSize page size
   * @param currentPage current page
   * @param sort sort
   */
  loadOrderList(pageSize, currentPage, sort) {
    this.userIdService.takeUserId(true).subscribe({
      next: userId => {
        let replenishmentOrderCode;
        this.routingService.getRouterState().pipe(take(1)).subscribe(data => {
          replenishmentOrderCode = data?.state?.params?.replenishmentOrderCode;
        }).unsubscribe();
        this.store.dispatch(new LoadUserOrders({
          userId,
          pageSize,
          currentPage,
          sort,
          replenishmentOrderCode
        }));
      },
      error: () => {
        // TODO: for future releases, refactor this part to thrown errors
      }
    });
  }
  /**
   * Cleaning order list
   */
  clearOrderList() {
    this.store.dispatch(new ClearUserOrders());
  }
  /**
   *  Returns a consignment tracking detail
   */
  getConsignmentTracking() {
    return this.store.pipe(select(getConsignmentTracking));
  }
  /**
   * Retrieves consignment tracking details
   * @param orderCode an order code
   * @param consignmentCode a consignment code
   */
  loadConsignmentTracking(orderCode, consignmentCode) {
    this.userIdService.takeUserId().subscribe(userId => {
      this.store.dispatch(new LoadConsignmentTracking({
        userId,
        orderCode,
        consignmentCode
      }));
    });
  }
  /**
   * Cleaning consignment tracking
   */
  clearConsignmentTracking() {
    this.store.dispatch(new ClearConsignmentTracking());
  }
  /*
   * Cancel an order
   */
  cancelOrder(orderCode, cancelRequestInput) {
    this.userIdService.takeUserId().subscribe(userId => {
      this.store.dispatch(new CancelOrder({
        userId,
        orderCode,
        cancelRequestInput
      }));
    });
  }
  /**
   * Returns the cancel order loading flag
   */
  getCancelOrderLoading() {
    return this.processStateStore.pipe(select(ProcessSelectors.getProcessLoadingFactory(CANCEL_ORDER_PROCESS_ID)));
  }
  /**
   * Returns the cancel order success flag
   */
  getCancelOrderSuccess() {
    return this.processStateStore.pipe(select(ProcessSelectors.getProcessSuccessFactory(CANCEL_ORDER_PROCESS_ID)));
  }
  /**
   * Resets the cancel order process flags
   */
  resetCancelOrderProcessState() {
    return this.store.dispatch(new ResetCancelOrderProcess());
  }
  /**
   * Returns the order details loading flag
   */
  getOrderDetailsLoading() {
    return this.store.pipe(select(getOrderDetailsLoading));
  }
  /**
   * @deprecated: Method doesn't pass facade method's requirements (returns void or Observable)
   */
  getQueryParams(_order) {
    return null;
  }
  static {
    this.ɵfac = function OrderHistoryService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderHistoryService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.RoutingService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderHistoryService,
      factory: OrderHistoryService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderHistoryService, [{
    type: Injectable
  }], () => [{
    type: i1.Store
  }, {
    type: i1.Store
  }, {
    type: i2.UserIdService
  }, {
    type: i2.RoutingService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderReturnRequestService {
  constructor(store, processStateStore, userIdService) {
    this.store = store;
    this.processStateStore = processStateStore;
    this.userIdService = userIdService;
  }
  /**
   * Create order return request
   * @param orderCode an order code
   * @param returnRequestInput order return request entry input
   */
  createOrderReturnRequest(returnRequestInput) {
    this.userIdService.takeUserId().subscribe(userId => {
      this.store.dispatch(new CreateOrderReturnRequest({
        userId,
        returnRequestInput
      }));
    });
  }
  /**
   * Return an order return request
   */
  getOrderReturnRequest() {
    return this.store.pipe(select(getOrderReturnRequest));
  }
  /**
   * Gets order return request list
   */
  getOrderReturnRequestList(pageSize) {
    return this.store.pipe(select(getOrderReturnRequestListState), tap(returnListState => {
      const attemptedLoad = returnListState.loading || returnListState.success || returnListState.error;
      if (!attemptedLoad) {
        this.loadOrderReturnRequestList(pageSize);
      }
    }), map(returnListState => returnListState.value));
  }
  /**
   * Loads order return request detail
   * @param returnRequestCode
   */
  loadOrderReturnRequestDetail(returnRequestCode) {
    this.userIdService.takeUserId().subscribe(userId => {
      this.store.dispatch(new LoadOrderReturnRequest({
        userId,
        returnRequestCode
      }));
    });
  }
  /**
   * Loads order return request list
   * @param pageSize page size
   * @param currentPage current page
   * @param sort sort
   */
  loadOrderReturnRequestList(pageSize, currentPage, sort) {
    this.userIdService.takeUserId(true).subscribe({
      next: userId => {
        this.store.dispatch(new LoadOrderReturnRequestList({
          userId,
          pageSize,
          currentPage,
          sort
        }));
      },
      error: () => {
        // TODO: for future releases, refactor this part to thrown errors
      }
    });
  }
  /**
   * Cleaning order return request list
   */
  clearOrderReturnRequestList() {
    this.store.dispatch(new ClearOrderReturnRequestList());
  }
  /**
   * Get the order return request loading flag
   */
  getReturnRequestLoading() {
    return this.store.pipe(select(getOrderReturnRequestLoading));
  }
  /**
   * Get the order return request success flag
   */
  getReturnRequestSuccess() {
    return this.store.pipe(select(getOrderReturnRequestSuccess));
  }
  /**
   * Cleaning order return request details
   */
  clearOrderReturnRequestDetail() {
    this.store.dispatch(new ClearOrderReturnRequest());
  }
  /*
   * Cancel order return request
   */
  cancelOrderReturnRequest(returnRequestCode, returnRequestModification) {
    this.userIdService.takeUserId().subscribe(userId => {
      this.store.dispatch(new CancelOrderReturnRequest({
        userId,
        returnRequestCode,
        returnRequestModification
      }));
    });
  }
  /**
   * Returns the cancel return request loading flag
   */
  getCancelReturnRequestLoading() {
    return this.processStateStore.pipe(select(ProcessSelectors.getProcessLoadingFactory(CANCEL_RETURN_PROCESS_ID)));
  }
  /**
   * Returns the cancel return request success flag
   */
  getCancelReturnRequestSuccess() {
    return this.processStateStore.pipe(select(ProcessSelectors.getProcessSuccessFactory(CANCEL_RETURN_PROCESS_ID)));
  }
  /**
   * Resets the cancel return request process flags
   */
  resetCancelReturnRequestProcessState() {
    return this.store.dispatch(new ResetCancelReturnProcess());
  }
  static {
    this.ɵfac = function OrderReturnRequestService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderReturnRequestService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.UserIdService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderReturnRequestService,
      factory: OrderReturnRequestService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderReturnRequestService, [{
    type: Injectable
  }], () => [{
    type: i1.Store
  }, {
    type: i1.Store
  }, {
    type: i2.UserIdService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderService {
  constructor(activeCartFacade, userIdService, commandService, orderConnector, eventService) {
    this.activeCartFacade = activeCartFacade;
    this.userIdService = userIdService;
    this.commandService = commandService;
    this.orderConnector = orderConnector;
    this.eventService = eventService;
    this.placedOrder$ = new BehaviorSubject(undefined);
    this.placeOrderCommand = this.commandService.create(payload => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.orderConnector.placeOrder(userId, cartId, payload).pipe(tap(order => {
      this.placedOrder$.next(order);
      this.eventService.dispatch({
        userId,
        cartId,
        /**
         * As we know the cart is not anonymous (precondition checked),
         * we can safely use the cartId, which is actually the cart.code.
         */
        cartCode: cartId,
        order
      }, OrderPlacedEvent);
    })))), {
      strategy: CommandStrategy.CancelPrevious
    });
    this.placePaymentAuthorizedOrderCommand = this.commandService.create(payload => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.orderConnector.placePaymentAuthorizedOrder(userId, cartId, payload).pipe(tap(order => {
      this.setPlacedOrder(order);
      this.eventService.dispatch({
        order,
        userId,
        cartId,
        /**
         * As we know the cart is not anonymous (precondition checked),
         * we can safely use the cartId, which is actually the cart.code.
         */
        cartCode: cartId
      }, OrderPlacedEvent);
    })))), {
      strategy: CommandStrategy.CancelPrevious
    });
  }
  /**
   * Performs the necessary checkout preconditions.
   */
  checkoutPreconditions() {
    return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
      if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
        throw new Error('Checkout conditions not met');
      }
      return [userId, cartId];
    }));
  }
  placeOrder(termsChecked) {
    return this.placeOrderCommand.execute(termsChecked);
  }
  placePaymentAuthorizedOrder(termsChecked) {
    return this.placePaymentAuthorizedOrderCommand.execute(termsChecked);
  }
  getOrderDetails() {
    return this.placedOrder$.asObservable();
  }
  clearPlacedOrder() {
    this.placedOrder$.next(undefined);
  }
  setPlacedOrder(order) {
    this.placedOrder$.next(order);
  }
  getPickupEntries() {
    return this.getOrderDetails().pipe(map(order => order?.entries?.filter(entry => entry.deliveryPointOfService !== undefined) || []));
  }
  getDeliveryEntries() {
    return this.getOrderDetails().pipe(map(order => order?.entries?.filter(entry => entry.deliveryPointOfService === undefined) || []));
  }
  static {
    this.ɵfac = function OrderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderService)(i0.ɵɵinject(i3.ActiveCartFacade), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.CommandService), i0.ɵɵinject(OrderConnector), i0.ɵɵinject(i2.EventService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderService,
      factory: OrderService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderService, [{
    type: Injectable
  }], () => [{
    type: i3.ActiveCartFacade
  }, {
    type: i2.UserIdService
  }, {
    type: i2.CommandService
  }, {
    type: OrderConnector
  }, {
    type: i2.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReorderOrderService {
  constructor(commandService, reorderOrderConnector, userIdService, activeCartFacade, multiCartFacade) {
    this.commandService = commandService;
    this.reorderOrderConnector = reorderOrderConnector;
    this.userIdService = userIdService;
    this.activeCartFacade = activeCartFacade;
    this.multiCartFacade = multiCartFacade;
    this.reorderCommand = this.commandService.create(({
      orderId
    }) => this.reorderPreconditions().pipe(switchMap(userId => this.reorderOrderConnector.reorder(orderId, userId))), {
      strategy: CommandStrategy.CancelPrevious
    });
  }
  /**
   * Create cart from an existing order
   */
  reorder(orderId) {
    return this.reorderCommand.execute({
      orderId
    });
  }
  reorderPreconditions() {
    return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.getActiveCartId()]).pipe(take(1), map(([userId, cartId]) => {
      if (!userId) {
        throw new Error('Must be logged in to reorder');
      }
      if (cartId) {
        this.multiCartFacade.deleteCart(cartId, userId);
      }
      return userId;
    }));
  }
  static {
    this.ɵfac = function ReorderOrderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReorderOrderService)(i0.ɵɵinject(i2.CommandService), i0.ɵɵinject(ReorderOrderConnector), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i3.ActiveCartFacade), i0.ɵɵinject(i3.MultiCartFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReorderOrderService,
      factory: ReorderOrderService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReorderOrderService, [{
    type: Injectable
  }], () => [{
    type: i2.CommandService
  }, {
    type: ReorderOrderConnector
  }, {
    type: i2.UserIdService
  }, {
    type: i3.ActiveCartFacade
  }, {
    type: i3.MultiCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderHistoryService {
  constructor(store, processStateStore, userIdService) {
    this.store = store;
    this.processStateStore = processStateStore;
    this.userIdService = userIdService;
  }
  /**
   * Returns replenishment order details for a given 'current' user
   *
   * @param replenishmentOrderCode a replenishment order code
   */
  loadReplenishmentOrderDetails(replenishmentOrderCode) {
    this.userIdService.takeUserId(true).subscribe({
      next: userId => {
        this.store.dispatch(new LoadReplenishmentOrderDetails({
          userId,
          replenishmentOrderCode
        }));
      },
      error: () => {
        // TODO: for future releases, refactor this part to thrown errors
      }
    });
  }
  /**
   * Returns a replenishment order details
   */
  getReplenishmentOrderDetails() {
    return this.store.pipe(select(getReplenishmentOrderDetailsValue));
  }
  /**
   * Returns a replenishment order details loading flag
   */
  getReplenishmentOrderDetailsLoading() {
    return this.store.pipe(select(getReplenishmentOrderDetailsLoading));
  }
  /**
   * Returns a replenishment order details success flag
   */
  getReplenishmentOrderDetailsSuccess() {
    return this.store.pipe(select(getReplenishmentOrderDetailsSuccess));
  }
  /**
   * Returns a replenishment order details error flag
   */
  getReplenishmentOrderDetailsError() {
    return this.store.pipe(select(getReplenishmentOrderDetailsError));
  }
  /**
   * Clears the replenishment orders details state
   */
  clearReplenishmentOrderDetails() {
    this.store.dispatch(new ClearReplenishmentOrderDetails());
  }
  /**
   * Cancels a specific replenishment order for a given 'current' user
   *
   * @param replenishmentOrderCode a replenishment order code
   */
  cancelReplenishmentOrder(replenishmentOrderCode) {
    this.userIdService.takeUserId(true).subscribe({
      next: userId => {
        this.store.dispatch(new CancelReplenishmentOrder({
          userId,
          replenishmentOrderCode
        }));
      },
      error: () => {
        // TODO: for future releases, refactor this part to thrown errors
      }
    });
  }
  /**
   * Returns the cancel replenishment order loading flag
   */
  getCancelReplenishmentOrderLoading() {
    return this.processStateStore.pipe(select(ProcessSelectors.getProcessLoadingFactory(CANCEL_REPLENISHMENT_ORDER_PROCESS_ID)));
  }
  /**
   * Returns the cancel replenishment order success flag
   */
  getCancelReplenishmentOrderSuccess() {
    return this.processStateStore.pipe(select(ProcessSelectors.getProcessSuccessFactory(CANCEL_REPLENISHMENT_ORDER_PROCESS_ID)));
  }
  /**
   * Returns the cancel replenishment order error flag
   */
  getCancelReplenishmentOrderError() {
    return this.processStateStore.pipe(select(ProcessSelectors.getProcessErrorFactory(CANCEL_REPLENISHMENT_ORDER_PROCESS_ID)));
  }
  /**
   * Clears the cancel replenishment order processing state
   */
  clearCancelReplenishmentOrderProcessState() {
    this.store.dispatch(new ClearCancelReplenishmentOrder());
  }
  /**
   * Returns replenishment order history list
   */
  getReplenishmentOrderHistoryList(pageSize) {
    return this.store.pipe(select(getReplenishmentOrdersState), tap(replenishmentOrderListState => {
      const attemptedLoad = replenishmentOrderListState.loading || replenishmentOrderListState.success || replenishmentOrderListState.error;
      if (!attemptedLoad) {
        this.loadReplenishmentOrderList(pageSize);
      }
    }), map(replenishmentOrderListState => replenishmentOrderListState.value));
  }
  /**
   * Returns a loading flag for replenishment order history list
   */
  getReplenishmentOrderHistoryListLoading() {
    return this.store.pipe(select(getReplenishmentOrdersLoading));
  }
  /**
   * Returns a error flag for replenishment order history list
   */
  getReplenishmentOrderHistoryListError() {
    return this.store.pipe(select(getReplenishmentOrdersError));
  }
  /**
   * Returns a success flag for replenishment order history list
   */
  getReplenishmentOrderHistoryListSuccess() {
    return this.store.pipe(select(getReplenishmentOrdersSuccess));
  }
  /**
   * Retrieves a replenishment order list
   * @param pageSize page size
   * @param currentPage current page
   * @param sort sort
   */
  loadReplenishmentOrderList(pageSize, currentPage, sort) {
    this.userIdService.takeUserId(true).subscribe({
      next: userId => {
        this.store.dispatch(new LoadUserReplenishmentOrders({
          userId,
          pageSize,
          currentPage,
          sort
        }));
      },
      error: () => {
        // TODO: for future releases, refactor this part to thrown errors
      }
    });
  }
  /**
   * Cleaning replenishment order list
   */
  clearReplenishmentOrderList() {
    this.store.dispatch(new ClearUserReplenishmentOrders());
  }
  static {
    this.ɵfac = function ReplenishmentOrderHistoryService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderHistoryService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.UserIdService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReplenishmentOrderHistoryService,
      factory: ReplenishmentOrderHistoryService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderHistoryService, [{
    type: Injectable
  }], () => [{
    type: i1.Store
  }, {
    type: i1.Store
  }, {
    type: i2.UserIdService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScheduledReplenishmentOrderService {
  constructor(activeCartFacade, userIdService, commandService, scheduledReplenishmentOrderConnector, eventService, orderFacade) {
    this.activeCartFacade = activeCartFacade;
    this.userIdService = userIdService;
    this.commandService = commandService;
    this.scheduledReplenishmentOrderConnector = scheduledReplenishmentOrderConnector;
    this.eventService = eventService;
    this.orderFacade = orderFacade;
    this.scheduleReplenishmentOrderCommand = this.commandService.create(({
      form,
      termsChecked
    }) => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.scheduledReplenishmentOrderConnector.scheduleReplenishmentOrder(cartId, form, termsChecked, userId).pipe(tap(replenishmentOrder => {
      this.orderFacade.setPlacedOrder(replenishmentOrder);
      this.eventService.dispatch({
        userId,
        cartId,
        /**
         * As we know the cart is not anonymous (precondition checked),
         * we can safely use the cartId, which is actually the cart.code.
         */
        cartCode: cartId,
        replenishmentOrder
      }, ReplenishmentOrderScheduledEvent);
    })))), {
      strategy: CommandStrategy.CancelPrevious
    });
  }
  checkoutPreconditions() {
    return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
      if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
        throw new Error('Order conditions not met');
      }
      return [userId, cartId];
    }));
  }
  /**
   * Schedule a replenishment order
   */
  scheduleReplenishmentOrder(scheduleReplenishmentForm, termsChecked) {
    return this.scheduleReplenishmentOrderCommand.execute({
      termsChecked,
      form: scheduleReplenishmentForm
    });
  }
  static {
    this.ɵfac = function ScheduledReplenishmentOrderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScheduledReplenishmentOrderService)(i0.ɵɵinject(i3.ActiveCartFacade), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.CommandService), i0.ɵɵinject(ScheduledReplenishmentOrderConnector), i0.ɵɵinject(i2.EventService), i0.ɵɵinject(i4.OrderFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScheduledReplenishmentOrderService,
      factory: ScheduledReplenishmentOrderService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScheduledReplenishmentOrderService, [{
    type: Injectable
  }], () => [{
    type: i3.ActiveCartFacade
  }, {
    type: i2.UserIdService
  }, {
    type: i2.CommandService
  }, {
    type: ScheduledReplenishmentOrderConnector
  }, {
    type: i2.EventService
  }, {
    type: i4.OrderFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsignmentTrackingByIdEffects {
  constructor() {
    this.logger = inject(LoggerService);
    this.actions$ = inject(Actions);
    this.orderConnector = inject(OrderHistoryConnector);
    this.loadConsignmentTrackingById$ = createEffect(() => this.actions$.pipe(ofType(LOAD_CONSIGNMENT_TRACKING_BY_ID), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.getConsignmentTracking(payload.orderCode, payload.consignmentCode, payload.userId).pipe(map(tracking => new LoadConsignmentTrackingByIdSuccess({
        orderCode: payload.orderCode,
        consignmentCode: payload.consignmentCode,
        consignmentTracking: tracking
      })), catchError(error => of(new LoadConsignmentTrackingByIdFail({
        orderCode: payload.orderCode,
        consignmentCode: payload.consignmentCode,
        error: tryNormalizeHttpError(error, this.logger)
      }))));
    })));
  }
  static {
    this.ɵfac = function ConsignmentTrackingByIdEffects_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConsignmentTrackingByIdEffects)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ConsignmentTrackingByIdEffects,
      factory: ConsignmentTrackingByIdEffects.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsignmentTrackingByIdEffects, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsignmentTrackingEffects {
  constructor(actions$, orderConnector) {
    this.actions$ = actions$;
    this.orderConnector = orderConnector;
    this.logger = inject(LoggerService);
    this.loadConsignmentTracking$ = createEffect(() => this.actions$.pipe(ofType(LOAD_CONSIGNMENT_TRACKING), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.getConsignmentTracking(payload.orderCode, payload.consignmentCode, payload.userId).pipe(map(tracking => new LoadConsignmentTrackingSuccess(tracking)), catchError(error => of(new LoadConsignmentTrackingFail(tryNormalizeHttpError(error, this.logger)))));
    })));
  }
  static {
    this.ɵfac = function ConsignmentTrackingEffects_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConsignmentTrackingEffects)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(OrderHistoryConnector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ConsignmentTrackingEffects,
      factory: ConsignmentTrackingEffects.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsignmentTrackingEffects, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: OrderHistoryConnector
  }], null);
})();
class OrderByIdEffect {
  constructor() {
    this.logger = inject(LoggerService);
    this.actions$ = inject(Actions);
    this.orderConnector = inject(OrderHistoryConnector);
    this.loadOrderById$ = createEffect(() => this.actions$.pipe(ofType(LOAD_ORDER_BY_ID), map(action => action.payload), mergeMap(({
      userId,
      code
    }) => {
      return this.orderConnector.get(userId, code).pipe(map(order => {
        return new LoadOrderByIdSuccess(order);
      }), catchError(error => {
        return of(new LoadOrderByIdFail({
          code,
          error: tryNormalizeHttpError(error, this.logger)
        }));
      }));
    })));
  }
  static {
    this.ɵfac = function OrderByIdEffect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderByIdEffect)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderByIdEffect,
      factory: OrderByIdEffect.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderByIdEffect, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailsEffect {
  constructor(actions$, orderConnector, globalMessageService, userIdService, store) {
    this.actions$ = actions$;
    this.orderConnector = orderConnector;
    this.globalMessageService = globalMessageService;
    this.userIdService = userIdService;
    this.store = store;
    this.logger = inject(LoggerService);
    this.loadOrderDetails$ = createEffect(() => this.actions$.pipe(ofType(LOAD_ORDER_DETAILS), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.get(payload.userId, payload.orderCode).pipe(map(order => {
        return new LoadOrderDetailsSuccess(order);
      }), catchError(error => of(new LoadOrderDetailsFail(tryNormalizeHttpError(error, this.logger)))));
    })));
    this.cancelOrder$ = createEffect(() => this.actions$.pipe(ofType(CANCEL_ORDER), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.cancel(payload.userId, payload.orderCode, payload.cancelRequestInput).pipe(map(() => new CancelOrderSuccess()), catchError(error => {
        error.error?.errors.forEach(err => this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR));
        return of(new CancelOrderFail(tryNormalizeHttpError(error, this.logger)));
      }));
    })));
    this.resetOrderDetails$ = createEffect(() => this.actions$.pipe(ofType(SiteContextActions.LANGUAGE_CHANGE, SiteContextActions.CURRENCY_CHANGE), withLatestFrom(this.userIdService.getUserId(), this.store.pipe(filter(store => !!store.order?.orderDetail), map(state => state.order.orderDetail.value?.code))), switchMap(([, userId, orderCode]) => {
      if (orderCode) {
        return this.orderConnector.get(userId, orderCode).pipe(map(order => {
          return new LoadOrderDetailsSuccess(order);
        }), catchError(error => of(new LoadOrderDetailsFail(tryNormalizeHttpError(error, this.logger)))));
      }
      return EMPTY;
    })));
  }
  static {
    this.ɵfac = function OrderDetailsEffect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailsEffect)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(OrderHistoryConnector), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i1.Store));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderDetailsEffect,
      factory: OrderDetailsEffect.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailsEffect, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: OrderHistoryConnector
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i2.UserIdService
  }, {
    type: i1.Store
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderReturnRequestEffect {
  constructor(actions$, orderConnector) {
    this.actions$ = actions$;
    this.orderConnector = orderConnector;
    this.logger = inject(LoggerService);
    this.createReturnRequest$ = createEffect(() => this.actions$.pipe(ofType(CREATE_ORDER_RETURN_REQUEST), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.return(payload.userId, payload.returnRequestInput).pipe(map(returnRequest => new CreateOrderReturnRequestSuccess(returnRequest)), catchError(error => of(new CreateOrderReturnRequestFail(tryNormalizeHttpError(error, this.logger)))));
    })));
    this.loadReturnRequest$ = createEffect(() => this.actions$.pipe(ofType(LOAD_ORDER_RETURN_REQUEST), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.getReturnRequestDetail(payload.userId, payload.returnRequestCode).pipe(map(returnRequest => new LoadOrderReturnRequestSuccess(returnRequest)), catchError(error => of(new LoadOrderReturnRequestFail(tryNormalizeHttpError(error, this.logger)))));
    })));
    this.cancelReturnRequest$ = createEffect(() => this.actions$.pipe(ofType(CANCEL_ORDER_RETURN_REQUEST), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.cancelReturnRequest(payload.userId, payload.returnRequestCode, payload.returnRequestModification).pipe(map(() => new CancelOrderReturnRequestSuccess()), catchError(error => of(new CancelOrderReturnRequestFail(tryNormalizeHttpError(error, this.logger)))));
    })));
    this.loadReturnRequestList$ = createEffect(() => this.actions$.pipe(ofType(LOAD_ORDER_RETURN_REQUEST_LIST), map(action => action.payload), switchMap(payload => {
      return this.orderConnector.getReturnRequestList(payload.userId, payload.pageSize, payload.currentPage, payload.sort).pipe(map(returnRequestList => new LoadOrderReturnRequestListSuccess(returnRequestList)), catchError(error => of(new LoadOrderReturnRequestListFail(tryNormalizeHttpError(error, this.logger)))));
    })));
  }
  static {
    this.ɵfac = function OrderReturnRequestEffect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderReturnRequestEffect)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(OrderHistoryConnector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderReturnRequestEffect,
      factory: OrderReturnRequestEffect.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderReturnRequestEffect, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: OrderHistoryConnector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrdersEffect {
  constructor(actions$, orderConnector, replenishmentOrderConnector) {
    this.actions$ = actions$;
    this.orderConnector = orderConnector;
    this.replenishmentOrderConnector = replenishmentOrderConnector;
    this.logger = inject(LoggerService);
    this.loadUserOrders$ = createEffect(() => this.actions$.pipe(ofType(LOAD_USER_ORDERS), map(action => action.payload), switchMap(payload => {
      return (Boolean(payload.replenishmentOrderCode) ? this.replenishmentOrderConnector.loadReplenishmentDetailsHistory(payload.userId, payload.replenishmentOrderCode ?? '', payload.pageSize, payload.currentPage, payload.sort) : this.orderConnector.getHistory(payload.userId, payload.pageSize, payload.currentPage, payload.sort)).pipe(map(orders => {
        return new LoadUserOrdersSuccess(orders);
      }), catchError(error => of(new LoadUserOrdersFail(tryNormalizeHttpError(error, this.logger)))));
    })));
    this.resetUserOrders$ = createEffect(() => this.actions$.pipe(ofType(SiteContextActions.LANGUAGE_CHANGE), map(() => {
      return new ClearUserOrders();
    })));
  }
  static {
    this.ɵfac = function OrdersEffect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrdersEffect)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(OrderHistoryConnector), i0.ɵɵinject(ReplenishmentOrderHistoryConnector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrdersEffect,
      factory: OrdersEffect.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrdersEffect, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: OrderHistoryConnector
  }, {
    type: ReplenishmentOrderHistoryConnector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderDetailsEffect {
  constructor(actions$, replenishmentOrderConnector, globalMessageService) {
    this.actions$ = actions$;
    this.replenishmentOrderConnector = replenishmentOrderConnector;
    this.globalMessageService = globalMessageService;
    this.logger = inject(LoggerService);
    this.loadReplenishmentOrderDetails$ = createEffect(() => this.actions$.pipe(ofType(LOAD_REPLENISHMENT_ORDER_DETAILS), map(action => action.payload), switchMap(payload => {
      return this.replenishmentOrderConnector.load(payload.userId, payload.replenishmentOrderCode).pipe(map(replenishmentOrder => {
        return new LoadReplenishmentOrderDetailsSuccess(replenishmentOrder);
      }), catchError(error => of(new LoadReplenishmentOrderDetailsFail(tryNormalizeHttpError(error, this.logger)))));
    })));
    this.cancelReplenishmentOrder$ = createEffect(() => this.actions$.pipe(ofType(CANCEL_REPLENISHMENT_ORDER), map(action => action.payload), switchMap(payload => {
      return this.replenishmentOrderConnector.cancelReplenishmentOrder(payload.userId, payload.replenishmentOrderCode).pipe(map(replenishmentOrder => new CancelReplenishmentOrderSuccess(replenishmentOrder)), catchError(error => {
        error?.error?.errors.forEach(err => this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR));
        return of(new CancelReplenishmentOrderFail(tryNormalizeHttpError(error, this.logger)));
      }));
    })));
  }
  static {
    this.ɵfac = function ReplenishmentOrderDetailsEffect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderDetailsEffect)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(ReplenishmentOrderHistoryConnector), i0.ɵɵinject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReplenishmentOrderDetailsEffect,
      factory: ReplenishmentOrderDetailsEffect.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderDetailsEffect, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: ReplenishmentOrderHistoryConnector
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrdersEffect {
  constructor(actions$, replenishmentOrderConnector) {
    this.actions$ = actions$;
    this.replenishmentOrderConnector = replenishmentOrderConnector;
    this.logger = inject(LoggerService);
    this.loadUserReplenishmentOrders$ = createEffect(() => this.actions$.pipe(ofType(LOAD_USER_REPLENISHMENT_ORDERS), map(action => action.payload), switchMap(payload => {
      return this.replenishmentOrderConnector.loadHistory(payload.userId, payload.pageSize, payload.currentPage, payload.sort).pipe(map(orders => {
        return new LoadUserReplenishmentOrdersSuccess(orders);
      }), catchError(error => of(new LoadUserReplenishmentOrdersFail(tryNormalizeHttpError(error, this.logger)))));
    })));
  }
  static {
    this.ɵfac = function ReplenishmentOrdersEffect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrdersEffect)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(ReplenishmentOrderHistoryConnector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReplenishmentOrdersEffect,
      factory: ReplenishmentOrdersEffect.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrdersEffect, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: ReplenishmentOrderHistoryConnector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const effects = [OrdersEffect, OrderDetailsEffect, ConsignmentTrackingEffects, OrderReturnRequestEffect, ReplenishmentOrderDetailsEffect, ReplenishmentOrdersEffect, ConsignmentTrackingByIdEffects, OrderByIdEffect];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialStateOfConsignmentTrackingById = undefined;
function reducer$7(state = initialStateOfConsignmentTrackingById, action) {
  switch (action.type) {
    case LOAD_CONSIGNMENT_TRACKING_BY_ID_SUCCESS:
      {
        return action.payload.consignmentTracking ? action.payload.consignmentTracking : initialStateOfConsignmentTrackingById;
      }
    case LOAD_CONSIGNMENT_TRACKING_BY_ID_FAIL:
      {
        return initialStateOfConsignmentTrackingById;
      }
  }
  return state;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialStateOfOrderById = undefined;
function reducer$6(state = initialStateOfOrderById, action) {
  switch (action.type) {
    case LOAD_ORDER_BY_ID_SUCCESS:
      {
        return action.payload ? action.payload : initialStateOfOrderById;
      }
    case LOAD_ORDER_BY_ID_FAIL:
      {
        return initialStateOfOrderById;
      }
  }
  return state;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialState$5 = {
  tracking: {}
};
function reducer$5(state = initialState$5, action) {
  switch (action.type) {
    case LOAD_CONSIGNMENT_TRACKING_SUCCESS:
      {
        const tracking = action.payload;
        return {
          tracking
        };
      }
    case CLEAR_CONSIGNMENT_TRACKING:
      {
        return initialState$5;
      }
  }
  return state;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialState$4 = {};
function reducer$4(state = initialState$4, action) {
  switch (action.type) {
    case LOAD_ORDER_DETAILS_SUCCESS:
      {
        const order = action.payload;
        return order;
      }
  }
  return state;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialState$3 = {
  returnRequests: [],
  pagination: {},
  sorts: []
};
function reducer$3(state = initialState$3, action) {
  switch (action.type) {
    case LOAD_ORDER_RETURN_REQUEST_LIST_SUCCESS:
      {
        return action.payload ? action.payload : initialState$3;
      }
  }
  return state;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialState$2 = {
  orders: [],
  pagination: {},
  sorts: []
};
function reducer$2(state = initialState$2, action) {
  switch (action.type) {
    case LOAD_USER_ORDERS_SUCCESS:
      {
        return action.payload ? action.payload : initialState$2;
      }
    case LOAD_USER_ORDERS_FAIL:
      {
        return initialState$2;
      }
  }
  return state;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialState$1 = {};
function reducer$1(state = initialState$1, action) {
  switch (action.type) {
    case LOAD_REPLENISHMENT_ORDER_DETAILS_SUCCESS:
    case CANCEL_REPLENISHMENT_ORDER_SUCCESS:
      {
        return action.payload ? action.payload : initialState$1;
      }
    default:
      {
        return state;
      }
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialState = {
  replenishmentOrders: [],
  pagination: {},
  sorts: []
};
function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_USER_REPLENISHMENT_ORDERS_SUCCESS:
      {
        return action.payload ? action.payload : initialState;
      }
    case CANCEL_REPLENISHMENT_ORDER_SUCCESS:
      {
        const cancelledReplenishmentOrder = action.payload;
        const userReplenishmentOrders = [...(state.replenishmentOrders ?? [])];
        const index = userReplenishmentOrders.findIndex(replenishmentOrder => replenishmentOrder.replenishmentOrderCode === cancelledReplenishmentOrder.replenishmentOrderCode);
        if (index === -1) {
          return initialState;
        } else {
          userReplenishmentOrders[index] = {
            ...cancelledReplenishmentOrder
          };
        }
        return {
          ...state,
          replenishmentOrders: userReplenishmentOrders
        };
      }
  }
  return state;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function getReducers() {
  return {
    orders: StateUtils.loaderReducer(ORDERS, reducer$2),
    orderDetail: StateUtils.loaderReducer(ORDER_DETAILS, reducer$4),
    replenishmentOrders: StateUtils.loaderReducer(REPLENISHMENT_ORDERS, reducer),
    orderReturn: StateUtils.loaderReducer(RETURN_REQUEST_DETAILS),
    orderReturnList: StateUtils.loaderReducer(RETURN_REQUESTS, reducer$3),
    consignmentTracking: reducer$5,
    replenishmentOrder: StateUtils.loaderReducer(REPLENISHMENT_ORDER_DETAILS, reducer$1),
    orderById: StateUtils.entityLoaderReducer(ORDER_BY_ID_ENTITIES, reducer$6),
    consignmentTrackingById: StateUtils.entityLoaderReducer(CONSIGNMENT_TRACKING_BY_ID_ENTITIES, reducer$7)
  };
}
const reducerToken = new InjectionToken('OrderReducers');
const reducerProvider = {
  provide: reducerToken,
  useFactory: getReducers
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2OrderHistoryService {
  constructor() {
    this.orderReturnRequestService = inject(OrderReturnRequestService);
    this.store = inject(Store);
    this.userIdService = inject(UserIdService);
    this.orderHistoryService = inject(OrderHistoryService);
  }
  clearOrderList() {
    this.orderHistoryService.clearOrderList();
  }
  getOrderDetailsWithTracking(orderCode) {
    return this.getOrderDetailsV2(orderCode).pipe(switchMap(order => {
      //-----------------> filling consignment tracking
      const orderView = {
        ...order
      };
      orderView.consignments = [];
      const requests = (order?.consignments ?? []).map(consignment => {
        const consignmentView = {
          ...consignment
        };
        if (consignment.code && consignment.trackingID) {
          return this.getConsignmentTracking(order?.code ?? '', consignment.code).pipe(map(trackingInfo => {
            consignmentView.consignmentTracking = trackingInfo;
            orderView.consignments?.push(consignmentView);
            return orderView;
          }));
        } else {
          orderView.consignments?.push(consignmentView);
          return of(orderView);
        }
      });
      if (requests === undefined || requests.length < 1) {
        return of(orderView);
      }
      return combineLatest(requests).pipe(switchMap(orders => {
        if (orders !== undefined) {
          return of(orders[0]);
        } else {
          return of(order);
        }
      }));
      //<-----------------
    }));
  }
  getOrderHistoryListWithDetails(pageSize) {
    const orderListView = {};
    return this.orderHistoryService.getOrderHistoryList(pageSize).pipe(switchMap(orderList => {
      orderListView.pagination = orderList?.pagination;
      orderListView.sorts = orderList?.sorts;
      orderListView.orders = [];
      const requests = (orderList?.orders ?? []).map(order => {
        const orderView = {
          ...order
        };
        return this.getOrderDetailsWithTracking(order?.code ?? '').pipe(map(orderDetail => {
          /** filling extra fields ---> */
          orderView.returnable = orderDetail?.returnable;
          orderView.totalItems = orderDetail?.totalItems;
          orderView.entries = orderDetail?.entries;
          orderView.consignments = orderDetail?.consignments;
          orderView.unconsignedEntries = orderDetail?.unconsignedEntries;
          orderView.returnRequests = [];
          /** filling extra fields <--- */
          orderListView.orders?.push(orderView);
          return orderListView;
        }));
      });
      if (requests.length === 0) {
        // in case of no order
        requests.push(of(orderListView));
      }
      return combineLatest(requests);
    }), map(requests => {
      if (requests !== undefined) {
        return requests[0];
      } else {
        return {};
      }
    }));
  }
  getOrderHistoryList(pageSize) {
    const orderHistoryListRequest = this.getOrderHistoryListWithDetails(pageSize);
    const returnRequestListRequest = this.orderReturnRequestService.getOrderReturnRequestList();
    return combineLatest([orderHistoryListRequest, returnRequestListRequest]).pipe(switchMap(responses => {
      const returnRequests = responses?.[1]?.returnRequests;
      const orderHistory = responses?.[0];
      if (returnRequests && orderHistory?.orders) {
        if (orderHistory.pagination?.totalResults === 0) {
          return of(orderHistory);
        }
        return orderHistory.orders.map(order => {
          const returnItems = returnRequests?.filter(returnItem => returnItem.order?.code === order.code);
          if (returnItems) {
            order.returnRequests = returnItems;
          }
          return orderHistory;
        });
      } else {
        return of(orderHistory);
      }
    }));
  }
  getOrderDetailsValue(code) {
    return this.store.select(getOrderById(code));
  }
  getOrderDetailsState(code) {
    return this.store.select(getOrderByIdEntity(code));
  }
  loadOrderDetails(code) {
    this.userIdService.takeUserId(true).subscribe({
      next: userId => this.store.dispatch(new LoadOrderById({
        userId,
        code
      }))
    });
  }
  getOrderDetailsV2(code) {
    const loading$ = this.getOrderDetailsState(code).pipe(auditTime(0), tap(state => {
      if (!(state.loading || state.success || state.error)) {
        this.loadOrderDetails(code);
      }
    }));
    return loading$.pipe(filter(state => (state.success || state.error) ?? false), map(state => {
      return state.value;
    }));
  }
  getConsignmentTrackingValue(orderCode, consignmentCode) {
    return this.store.select(getConsignmentTrackingById(orderCode, consignmentCode)).pipe(filter(tracking => Boolean(tracking)));
  }
  getConsignmentTrackingState(orderCode, consignmentCode) {
    return this.store.select(getConsignmentTrackingByIdEntity(orderCode, consignmentCode));
  }
  loadConsignmentTracking(orderCode, consignmentCode) {
    this.userIdService.takeUserId(true).subscribe({
      next: userId => this.store.dispatch(new LoadConsignmentTrackingById({
        orderCode,
        consignmentCode,
        userId
      }))
    });
  }
  getConsignmentTracking(orderCode, consignmentCode) {
    const loading$ = this.getConsignmentTrackingState(orderCode, consignmentCode).pipe(auditTime(0), tap(state => {
      if (!(state.loading || state.success || state.error)) {
        this.loadConsignmentTracking(orderCode, consignmentCode);
      }
    }));
    return using(() => loading$.subscribe(), () => this.getConsignmentTrackingValue(orderCode, consignmentCode));
  }
  static {
    this.ɵfac = function MyAccountV2OrderHistoryService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2OrderHistoryService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MyAccountV2OrderHistoryService,
      factory: MyAccountV2OrderHistoryService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2OrderHistoryService, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderAttachmentsService {
  constructor() {
    this.orderAttachmentsConnector = inject(OrderAttachmentsConnector);
    this.userIdService = inject(UserIdService);
  }
  getOrderAttachments(orderId) {
    return this.userIdService.takeUserId().pipe(take$1(1), switchMap$1(userId => this.orderAttachmentsConnector.getOrderAttachments(userId, orderId)));
  }
  downloadOrderAttachment(orderId, attachmentId) {
    return this.userIdService.takeUserId().pipe(take$1(1), switchMap$1(userId => this.orderAttachmentsConnector.downloadOrderAttachment(userId, orderId, attachmentId)));
  }
  static {
    this.ɵfac = function OrderAttachmentsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderAttachmentsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderAttachmentsService,
      factory: OrderAttachmentsService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderAttachmentsService, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const facadeProviders = [OrderReturnRequestService, {
  provide: OrderReturnRequestFacade,
  useExisting: OrderReturnRequestService
}, MyAccountV2OrderHistoryService, OrderHistoryService, {
  provide: OrderHistoryFacade,
  useExisting: OrderHistoryService
}, ReplenishmentOrderHistoryService, {
  provide: ReplenishmentOrderHistoryFacade,
  useExisting: ReplenishmentOrderHistoryService
}, ScheduledReplenishmentOrderService, {
  provide: ScheduledReplenishmentOrderFacade,
  useExisting: ScheduledReplenishmentOrderService
}, OrderService, {
  provide: OrderFacade,
  useExisting: OrderService
}, ReorderOrderService, {
  provide: ReorderOrderFacade,
  useExisting: ReorderOrderService
}, OrderAttachmentsService, {
  provide: OrderAttachmentsFacade,
  useExisting: OrderAttachmentsService
}];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderStoreModule {
  static {
    this.ɵfac = function OrderStoreModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderStoreModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderStoreModule,
      imports: [i1$1.EffectsFeatureModule, i1.StoreFeatureModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [reducerProvider],
      imports: [EffectsModule.forFeature(effects), StoreModule.forFeature(ORDER_FEATURE, reducerToken)]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderStoreModule, [{
    type: NgModule,
    args: [{
      imports: [EffectsModule.forFeature(effects), StoreModule.forFeature(ORDER_FEATURE, reducerToken)],
      providers: [reducerProvider]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderCoreModule {
  static {
    this.ɵfac = function OrderCoreModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderCoreModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderCoreModule,
      imports: [OrderStoreModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [...facadeProviders, OrderHistoryConnector, ReplenishmentOrderHistoryConnector, OrderConnector, ScheduledReplenishmentOrderConnector, ReorderOrderConnector, OrderAttachmentsConnector],
      imports: [OrderStoreModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderCoreModule, [{
    type: NgModule,
    args: [{
      imports: [OrderStoreModule],
      providers: [...facadeProviders, OrderHistoryConnector, ReplenishmentOrderHistoryConnector, OrderConnector, ScheduledReplenishmentOrderConnector, ReorderOrderConnector, OrderAttachmentsConnector]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CANCEL_ORDER_PROCESS_ID, CANCEL_REPLENISHMENT_ORDER_PROCESS_ID, CANCEL_RETURN_PROCESS_ID, CONSIGNMENT_TRACKING_BY_ID_ENTITIES, MyAccountV2OrderHistoryService, ORDERS, ORDER_BY_ID_ENTITIES, ORDER_DETAILS, ORDER_FEATURE, orderGroup_actions as OrderActions, OrderAdapter, OrderAttachmentsAdapter, OrderAttachmentsConnector, OrderAttachmentsService, OrderConnector, OrderCoreModule, OrderHistoryAdapter, OrderHistoryConnector, OrderHistoryService, OrderReturnRequestService, orderGroup_selectors as OrderSelectors, OrderService, REPLENISHMENT_ORDERS, REPLENISHMENT_ORDER_DETAILS, RETURN_REQUESTS, RETURN_REQUEST_DETAILS, ReorderOrderAdapter, ReorderOrderConnector, ReorderOrderService, ReplenishmentOrderHistoryAdapter, ReplenishmentOrderHistoryConnector, ReplenishmentOrderHistoryService, ScheduledReplenishmentOrderAdapter, ScheduledReplenishmentOrderConnector, ScheduledReplenishmentOrderService, getConsignmentTrackingByIdEntityKey };
